import { Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import FormError from "../../../components/FormError";
import { Icons } from "../../../components/icons";
import { AccordionContent } from "../../../components/ui/accordion";
import { Button } from "../../../components/ui/button";
import { Card } from "../../../components/ui/card";
import { Checkbox } from "../../../components/ui/checkbox";
import fetchData from "../../../utils/api";
import { Config } from "../../../utils/config";
import { PaymentMethodFormValidation } from "./Validation";

export default function PaymentMethodCart({
  cartList,
  authToken,
  id,
  restaurantDetail,
  handleCartList,
  handleAccordionClick,
}) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        method: cartList.paymentMethod?.method
          ? cartList.paymentMethod?.method
          : "",
      }}
      validationSchema={PaymentMethodFormValidation}
      onSubmit={async (values) => {
        setIsLoading(true);
        const cachedCart = localStorage.getItem("cart");
        try {
          const body: any = {
            cart_id: cachedCart,
            method: values.method,
          };
          const res = await fetchData({
            url: "cart/payment",
            method: "POST",
            body,
            token: authToken,
          });
          if (res.status_code === 200) {
            setIsLoading(false);
            handleCartList();
            handleAccordionClick(null);
          }
        } catch (error) {
          console.log("error", error);
        }
      }}
    >
      {({ errors, touched, setFieldValue, values, handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <AccordionContent className="grid p-2 gap-2">
            <div className="grid gap-2 w-full">
              {Config.env.app.payment_method.map((item, index) => {
                if (
                  item.value === "pay_online" &&
                  !restaurantDetail?.services?.online_payment
                ) {
                  // Skip the item if the condition is not matched
                  return null;
                }

                if (cartList.orderingMethod?.ordering_method === "pickup") {
                  if (
                    (item.value === "card" &&
                      !restaurantDetail?.paymentMethods?.card?.pickup) ||
                    (item.value === "cash" &&
                      !restaurantDetail?.paymentMethods?.cash?.pickup) ||
                    (item.value === "call_me_back" &&
                      !restaurantDetail?.paymentMethods?.call_me?.pickup) ||
                    (item.value === "qr_code_scan" &&
                      !restaurantDetail?.paymentMethods?.qr_code?.pickup)
                  ) {
                    // Skip the item if the condition is not matched
                    return null;
                  }
                }
                if (cartList.orderingMethod?.ordering_method === "delivery") {
                  if (
                    (item.value === "card" &&
                      !restaurantDetail?.paymentMethods?.card?.delivery) ||
                    (item.value === "cash" &&
                      !restaurantDetail?.paymentMethods?.cash?.delivery) ||
                    (item.value === "call_me_back" &&
                      !restaurantDetail?.paymentMethods?.call_me?.delivery) ||
                    (item.value === "qr_code_scan" &&
                      !restaurantDetail?.paymentMethods?.qr_code?.delivery)
                  ) {
                    // Skip the item if the condition is not matched
                    return null;
                  }
                }

                if (
                  cartList.orderingMethod?.ordering_method === "in_restaurant"
                ) {
                  if (
                    (item.value === "card" &&
                      !restaurantDetail?.paymentMethods?.card?.reservation) ||
                    (item.value === "cash" &&
                      !restaurantDetail?.paymentMethods?.cash?.reservation) ||
                    (item.value === "call_me_back" &&
                      !restaurantDetail?.paymentMethods?.call_me
                        ?.reservation) ||
                    (item.value === "qr_code_scan" &&
                      !restaurantDetail?.paymentMethods?.qr_code?.reservation)
                  ) {
                    // Skip the item if the condition is not matched
                    return null;
                  }
                }

                let cardService;

                if (cartList.orderingMethod?.ordering_method === "pickup") {
                  cardService = t(
                    "cart.payment_method.form.to_courier_partner"
                  );
                } else if (
                  cartList.orderingMethod?.ordering_method === "delivery"
                ) {
                  cardService = t(
                    "cart.payment_method.form.to_delivery_person"
                  );
                } else if (
                  cartList.orderingMethod?.ordering_method === "in_restaurant"
                ) {
                  cardService = t("cart.payment_method.form.in_restaurant");
                }

                return (
                  <Card id={item.label} className="p-0" key={index}>
                    <label
                      htmlFor={item.value}
                      className={`block p-3 ${
                        isLoading
                          ? "opacity-70 cursor-not-allowed"
                          : "cursor-pointer"
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        <Checkbox
                          disabled={isLoading}
                          id={item.value}
                          checked={values.method === item.value}
                          onCheckedChange={() => {
                            setFieldValue("method", item.value);
                          }}
                        />
                        <div className="flex justify-between w-full">
                          <p className="text-sm font-medium leading-[1.3]">
                            {t(item.label)}{" "}
                            {item.value === "card" && cardService}
                          </p>
                        </div>
                      </div>
                      {item.value === "qr_code_scan" && (
                        <p className="pt-2 opacity-50 text-sm">
                          {
                            restaurantDetail?.paymentMethods?.qr_code
                              ?.pickup_instructions
                          }
                        </p>
                      )}
                      {item.value === "pay_online" && (
                        <div className="pt-4 w-fit grid grid-flow-col gap-2 ">
                          {Config.env.app.online_payment_methods?.map(
                            (item) => (
                              <div>
                                <img
                                  alt={item.image}
                                  src={`${Config.env.app.image_url}${item.image}`}
                                  height={1000}
                                  width={1000}
                                  className="w-[48px] h-[32px]"
                                />
                              </div>
                            )
                          )}

                          {/* <div>
                          <img
                            alt="visa"
                            src={`${Config.env.app.image_url}/images/online-payments/mastercard.svg`}
                            height={1000}
                            width={1000}
                            className="w-[48px] h-[32px]"
                          />
                        </div>
                        <div>
                          <img
                            alt="visa"
                            src={`${Config.env.app.image_url}/images/online-payments/amex.svg`}
                            height={1000}
                            width={1000}
                            className="w-[48px] h-[32px]"
                          />
                        </div>
                        <div>
                          <img
                            alt="visa"
                            src={`${Config.env.app.image_url}/images/online-payments/discover.svg`}
                            height={1000}
                            width={1000}
                            className="w-[48px] h-[32px]"
                          />
                        </div>
                        <div>
                          <img
                            alt="visa"
                            src={`${Config.env.app.image_url}/images/online-payments/paypal.svg`}
                            height={1000}
                            width={1000}
                            className="w-[48px] h-[32px]"
                          />
                        </div> */}
                        </div>
                      )}
                    </label>
                  </Card>
                );
              })}
              {errors.method && touched.method ? (
                <FormError msg={t(errors.method.toString())} />
              ) : null}
            </div>

            <div className="flex justify-end w-full">
              <Button disabled={isLoading} type="submit">
                {isLoading && (
                  <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />
                )}
                {t("save")}
              </Button>
            </div>
          </AccordionContent>
        </form>
      )}
    </Formik>
  );
}
